module.exports = __webpack_public_path__ + "img/logo-choice-is-healthy-subhead.3f85e3ce.jpg";